module.exports = __webpack_public_path__ + "img/escape.df122a79.png";